export default __webpack_public_path__ + "static/media/Versions - vs Official vs Films_01.f8ccd85a.jpg";